const shouldBeInvoiced = (type: server.dto.SubscriptionTypes) => (type === "paid" || type === "readOnly");

const displayUserText = (type: server.dto.SubscriptionTypes) => (type === "paid");

const getPlanLabel = (type: server.dto.SubscriptionType, cycle: server.dto.BillingCycle) =>
  (shouldBeInvoiced(type.value)
    ? `${type.internalText} (${cycle.text})`
    : type.internalText);

const discountApplies = (subscriptionStart: Date, discountUntil?: Date) =>
  (discountUntil === null || new Date(discountUntil) >= new Date(subscriptionStart));

const subscriptionHasEndDate = (subscription: server.dto.Subscription) =>
  (new Date(subscription.end).getFullYear() < 2100);

export { shouldBeInvoiced, displayUserText, getPlanLabel, discountApplies, subscriptionHasEndDate };